import type { NextRequest } from "@/modules/fetch/types"
import type { ObjectToCamel } from "@/modules/format/types"
import type { FooterLink } from "@/modules/headerFooterFO/Footer/types"
import type { I18nLocale } from "@/modules/i18n/types"
import type { CollectionTypeResponse } from "@/modules/strapi/generated-types/api/output"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

type GetFooterLinksParams = {
  locale: I18nLocale
  req?: NextRequest
  token?: string
}

type GetFooterLinksResponse = FooterLink[]

type GetFooterLinksRawResponse = CollectionTypeResponse<"api::dedicated-home-page.dedicated-home-page">

const ENDPOINT = "/api/dedicated-home-pages"

export const getFooterLinksFromStrapi = async (params: GetFooterLinksParams): Promise<GetFooterLinksResponse> => {
  const { locale, req, token } = params
  const searchParams = new URLSearchParams()
  searchParams.set("locale", locale)

  return fetcher(ENDPOINT, {
    encodeUrl: false,
    nextRequest: req,
    requestInit: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    searchParams,
    serviceDomain: "STRAPI_API",
    storageKey: `footer-dedicated-home-pages::${locale}`,
    withUserSession: false,
  })
    .then(
      getResultFromResponse<GetFooterLinksRawResponse, ObjectToCamel<GetFooterLinksRawResponse>>({
        transformResult: toCamelCaseKeys,
      })
    )
    .then(({ data }) => data)
    .catch(handleFetchError(ENDPOINT, { locale }))
}
